module.exports = __webpack_public_path__ + "static/media/footer-socialmedia-instagram.a9804b34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/pullman/home/footer-socialmedia-instagram.svg
// module id = 1250
// module chunks = 0